<template>
  <div class="container">
    <h4 class="ta-center mt-3 mb-3">
      <strong>Inova Saúde Joinville</strong>
    </h4>
    <b-row>
      <b-col>
        <p>Instituições de saúde coletam grande volume de dados clínicos, de informação do paciente, dados administrativos e financeiros que se encontram dispersos em diferentes sistemas de informação em saúde. Os diversos sistemas de uma instituição, na maioria das vezes, devido a problemas de interoperabilidade, não têm capacidade de trocar essas informações entre si, e muito menos utilizar os dados coletados por esses sistemas de forma inteligente, não permitindo o apoio à decisão clínica, bem como decisões estratégicas de gestão.</p>
        <p>Diante desse desafio, a utilização do Business Intelligence (BI) é uma solução que permite analisar dados e processos de saúde de forma integrada, com o intuito de melhorar o processo e auxiliar no alcance de metas clínicas, de indicadores e de gestão, auxiliando em uma visão holística e com qualidade dos cuidados de saúde, melhorando o processo de negócio.</p>
      </b-col>
      <b-col xl="6">
        <b-img-lazy rounded class="w-100" src="../../assets/foto2.jpg" alt="Foto Equipe Inova" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p>O BI possibilita elaborar previsões com base nas informações históricas da organização por meio de metodologias que coletam, integram, analisam e disponibilizam dados transformando-os em informações significativas e úteis a fim de permitir “insights estratégicos, táticos e operacionais” mais eficazes e tomada de decisão.</p>
        <p>No Brasil, as primeiras iniciativas de incorporação dos conceitos de BI na área da saúde pública iniciaram em 2014 pelo Departamento de Informática do Sistema Único de Saúde (DATASUS), com o intuito de apoiar às decisões por meio das informações armazenadas ao longo da vida do cidadão (nascimento ao óbito), bem como produtividade, controle, avaliação e gestão dos estabelecimentos, órgãos e secretarias do Ministério.</p>
        <p>Dentro dessa mesma perspectiva, a Secretaria Municipal de Saúde de Joinville no início de 2018 criou o INOVA, projeto vinculado à Gerência de Gestão Estratégica, que tem por intuito auxiliar na análise estratégica e tomada de decisão em saúde dos diferentes setores da Secretaria Municipal de Saúde por meio do Business Intelligence.</p>
        <p>A iniciativa é pioneira e conta com servidores de carreira, o que consolida a ideia e dá continuidade ao trabalho desenvolvido. Nesse primeiro ano foram desenvolvidos diversos relatórios de BI, que deram início a ações específicas dentro de alguns serviços da Secretaria Municipal de Saúde. Acredita-se que o BI é ferramenta fundamental no processo de gestão e tem auxiliado na tomada de decisão mais assertiva</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "LandingPage"
};
</script>

<style>
p {
  text-indent: 2em;
  text-align: justify;
}
</style>
